const getUserImageLink = (fbUserId, width = 360, height = 360) => `https://graph.facebook.com/${fbUserId}/picture?width=${width}&height=${height}`;

export const facebookReviewsLink = 'https://www.facebook.com/pg/onmapltd/reviews/?ref=page_internal';

export const reviewsConfig = [
  {
    name: '‏‎ארי טל‎‏',
    photo: getUserImageLink('100009066600914'),
    message: 'חברים יקרים כבר יותר מחצי שנה אני עובד עים לוח נדלן און מאפ וכמוני כל אינפיניטי נדלן רבותיי על כל 10 טלפונים שאני מקבל 7 מתוכם מגיעים מאון מאפ לא רק שאני ממליץ זהו לוח נדלן חובה בכל חברת תיווך .\n  ורוצה להודות ליבגני זייליקוב הסוכן הסובלני והאדיב של און מאפ.\n  רבותי עד שלא תנסו לא תידעו \n  חובה !!!!!!!!!'
  },
  {
    name: 'מאיר שאשא‏',
    photo: getUserImageLink('100003821978443'),
    message: 'שלום אני מאיר שאשא מבעלי חמישה יועצי נדל"ן\n ברצוני להודות ולהמליץ על ולאדי וצוות onmap מאז שהפכנו ללקוחות שלהם אין ספק שכמות הלידים של המשרד עלתה, המשתמשים מדברים על אתר ידידותי למשתמש שהופך את החיפוש לנוח.\n בעקבות כך פונים אלינו המון מתעניינים.\n אנו משרד חמישה יועצי נדל"ן\n ממליצים בחום על שיתוף הפעולה העסקי איתם.\n בברכה\n חמישה יועצי נדלן'
  },
  {
    name: 'Eliyahu Baranes Paz',
    photo: getUserImageLink('722292809'),
    message: 'פשוט אתר מדהים אנחנו חששנו בהתחלה ומהרגע שפירסמנו אנחנו באיכות נכסים AAA סגרנו עיסקה תוך 24 שעות\n תודה על אתר מדהים'
  },
  {
    name: 'Slava Birman',
    photo: getUserImageLink('1431338490'),
    message: 'אתר ידידותי מאוד לחיפוש דירות. מומלץ בחום!'
  },
  {
    name: 'Véronique Ruth Sarfati',
    photo: getUserImageLink('100008109454916'),
    message: 'Des vrais communicants avec le service et l ecoute du client...je recommande'
  },
  {
    name: 'Yossef Hanania',
    photo: getUserImageLink('100000543808003'),
    message: 'מוצר חדשני וגאוני של צוות ONMAP היקרים . אני רוצה לציין לשבח את הסוכן יבגני היקר, על שירות אמינות ומקצועיות. ממליץ בחום על המוצר !'
  },
  {
    name: 'שוקי חודרה',
    photo: getUserImageLink('100004809970381'),
    message: 'הצטרפנו לפני מספר שבועות למרות התקופה הרגועה של השוק ....יש תנועה חיובית מאוד מהאתר והכי חשוב ההדרכה המקצועית ואין סוף הסבלנות מצד יבגני הסוכן אני אשית ממליץ על האתר'
  },
  {
    name: 'Shalom Tubul',
    photo: getUserImageLink('100024591834336'),
    message: 'אתר פירסום ממספר 1 עים שירות מעולה'
  },
  {
    name: 'Hanoam-Lioz Ron',
    photo: getUserImageLink('1040292642'),
    message: 'הצתרפנו לפני כ3-4 חודשים לשירותי OnMap בזכות יבגני שפשוט נחת עלי במשרד (:\n בתור משרד תיווך אנחנו מבינים את חשיבות ההשקעה בפרסום ותחשיבי יעילות של ההשקעה. לקחנו את החבילה בתור תוספת על הדרך..\n אך אני חייב להגיד שזה נהיה המקור העיקרי לפניות של הלקוחות למשרד. לדעתי זה בזכות הקלילות וידידותיות של האתר וגם של האפליקציה.. \n ללא פרסומים, הכל עולה ועובד במהירות, חוסך זמן רב גם לנו וגם ללקוחות. מומלץ !'
  },
  {
    name: 'Elena Hinchin',
    photo: getUserImageLink('100013918069195'),
    message: 'אתר מעולה! מצאתי דרכו את הדירה שלי שלא הופיעה בשום אתר אחר. חיפוש נוח, מהיר, ללא פרסומות. ביג לייק! ממליצה בחום!'
  },
  {
    name: 'מיכאל אופינקרו',
    photo: getUserImageLink('100021094216691'),
    message: 'יעילה חושפת ומיצרת לידים מומלץ!!!'
  },
  {
    name: 'Yifrach Yosef',
    photo: getUserImageLink('1578833651'),
    message: 'ממשק חיפוש ופירסום נכסים מציון שירות מציון של בעלי האתר אני מחובר אליהם זה כשבועיים\n מקבל טלפונים מדירות שאני מפרסם ממליץ בחום שווה עדיף בהרבה מיד 2 ומכל האתרים שאתם מכירים תנסו תופתעו לטובה כדאי מאוד'
  },
  {
    name: 'Yair Vardi',
    photo: getUserImageLink('650664569'),
    message: 'אפליקציה מצוינת עם ממשק קל לתפעול מומלץ בחום. אחלה מייזם שיהיה בהצלחה'
  },
  {
    name: 'חרמון מוטי',
    photo: getUserImageLink('100002169334530'),
    message: ', הגיע אלי יבגני, נציג מקצועי , סבלני, הציג את היתרונות הגלומות באתר ,שיכנע והצטרפתי בזכותו.\n האתר ידידותי למשתמש ומאפשר הכנסה והצגת נכסים ביעילות רבה.\n אני בטוח שלפחות שרות אקבל ביעילות ומהירות .מעבר ליתרון הגלום באתר, תודה ליבגני היקר\n בברכה ,מוטי חרמון\n תווך H&H 2000 סוקולוב 42 חולון'
  },
  {
    name: 'Victor Saada',
    photo: getUserImageLink('100000793302272'),
    message: 'מיום שהתחברתי לאון מאפ קיבלתי אמון תגובות ויענות על פרסום שהמשרד פירסם לכן ממליץ בחום להיצתרף ללוח און מאפ!'
  },
  {
    name: 'Dafna Ashri',
    photo: getUserImageLink('1824772371'),
    message: 'מעולה עוזר למצוא דירות אפילו שלא מכירה את הסביבה המפה עושה את העבודה בצורה יעלה מעוד'
  },
  {
    name: 'Irinka Barbie',
    photo: getUserImageLink('100005587273349'),
    message: 'אתר מאוד נוח לשימוש, עיצוב עדין ונעים לעין, הכל מסודר מאוד, ונוח בחיפוש אחר נכסים.\n ממליצה :)'
  },
  {
    name: 'Uzi Marom',
    photo: getUserImageLink('100009536241911'),
    message: 'חברה שהתחלתי לפרסם דרכם,עובד מול סוכן החברה ישירות מקבל שרות מקצועי מעולה. מהיר ענייני ופותר בעיות. נוח להשגה גם מעבר לשעות הקבלה. בניגוד ל"יד 2" איתם עבדתי שנים רבות ולא זכיתי לטיפול אישי ,ישיר ומקצועי, ממליץ בחום למתווכים להצטרף לשרות.'
  },
  {
    name: 'Yaniv Nahom',
    photo: getUserImageLink('100009316522138'),
    message: 'האפליקציה מאוד נגישה ונוחה\n השירות מעולה...\n אני עובד מול הסוכן ישירות ומקבל ממנו שירות מעולה ממליץ בחום'
  },
  {
    name: 'Ira Golan',
    photo: getUserImageLink('100002468921342'),
    message: 'חברים יקרים, ניסינו וגילינו - עובד ובגדול !!!! יש פניות ...יש עסקאות...ממליצה לכל הקולגות שלנו בחום!!! מחירים הוגנים שרות מעולה !!! ותודה לנציג שלנו יבגני'
  },
  {
    name: 'תיווך יועצים',
    photo: getUserImageLink('100012821474778'),
    message: 'שירות מצוין האתר מהיר נוח לעבודה יותר מאתרים אחרים....\n מומלץ בחום ואפילו יותר !!!'
  },
  {
    name: 'Shay Gat',
    photo: getUserImageLink('100002183809827'),
    message: 'חברה רצינית אני מקבל מהם שירות טוב ורצון לעזור כולל תמיכה'
  },
  {
    name: 'Nurit Shai',
    photo: getUserImageLink('1504483981'),
    message: 'ממליצה בחום!! שירות מעולה, יחס אדיב ומקצועי. אתר מהיר, נוח לחיפוש והכי חשוב- קיבלנו פניות מלקוחות חדשים!!!'
  },
  {
    name: 'Yariv Gur',
    photo: getUserImageLink('749108327'),
    message: 'ממשק נוח לתפעול (גם באפליקציה באייפון), מערכת חכמה, סיוע מעולה למשרדי התיווך ולמחפשי נכסים כאחד.\n עשינו ב OnMap חבילת פרסום בתשלום ויש כבר פניות (-:\n בהצלחה'
  },
  {
    name: 'Arik Hershman',
    photo: getUserImageLink('662212735'),
    message: 'בטוח שתגיעו לגדולות ...המון המון המון בהצלחה!!!'
  },
  {
    name: 'Alejka Snitkovsky',
    photo: getUserImageLink('100000541247160'),
    message: 'אתר נוח וקל לתפעול.\n קיבלתי יחס אישי ומקצועי מהסוכן של החברה שממשיך לתת מענה לכל שאלה גם מעבר לשעות המקובלות.\n והכי חשוב- קיבלנו פניות מלקוחות חדשים ומכרנו כמה דירות כבר!\n תודה רבה ממליץ בחום!'
  },
  {
    name: 'אלדד מיטלמן',
    photo: getUserImageLink('716634868'),
    message: 'אתר מעולה!'
  }
];
